export default function PHP_rename() {
  return (
    <div>
      <h1>PHP_rename</h1>
    </div>
  );
}
